import { Fragment } from 'react'
import { Inline, Text } from '@leroy-merlin-br/backyard-react'
import { StarRating } from 'hpdp/components'

import { Ellipsis } from 'shared/components/Ellipsis'

import { Shell } from '../../../Shell'
import * as S from './styled'

const MAX_SHORT_NAME_LENGTH = 61

interface ReviewRatingProps {
  avgRating: string
  totalReviewsCount: number
}

interface ProductInfoProps {
  name: string
  shortName: string
  id: number
  url: string
  hasServiceBadge: boolean
  reviewRating?: ReviewRatingProps
  isLoadingReview?: boolean
}

const ProductInfo = ({
  name,
  shortName,
  id,
  url,
  hasServiceBadge,
  reviewRating,
  isLoadingReview
}: ProductInfoProps) => {
  const shouldForceEllipsis =
    name.substring(0, MAX_SHORT_NAME_LENGTH) === shortName &&
    name.length > shortName.length

  const { defaultImagePath } = window.env

  const ReviewRating = () => {
    const content = isLoadingReview ? (
      <Shell width={'120px'} height={'20px'} borderRadius={'mega'} />
    ) : (
      <Inline space="bit" alignY="center">
        <StarRating color="primary" rating={Number(reviewRating?.avgRating)} />
        <Text as="span" size="kilo">
          ({reviewRating?.totalReviewsCount})
        </Text>
      </Inline>
    )

    return <S.ReviewWrapper>{content}</S.ReviewWrapper>
  }

  return (
    <Fragment>
      <S.Title href={url}>
        <Ellipsis clamp={3} as="h2">
          {shouldForceEllipsis ? `${shortName}...` : shortName}
        </Ellipsis>
      </S.Title>
      <S.MiddleWrapper>
        <S.ProductRating>
          <S.ProductCode>Cód. {id}</S.ProductCode>
          <ReviewRating />
        </S.ProductRating>
        {hasServiceBadge && (
          <S.ServiceBadge
            src={`${defaultImagePath}/icons/lmbr-services.svg`}
            alt="Logo do Leroy Merlin instala"
          />
        )}
      </S.MiddleWrapper>
    </Fragment>
  )
}

export default ProductInfo
